<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8coaiU/tc-custom/9780830899241.jpg?1696024616022" alt="This image is the cover for the book Still Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Still Life
      </h1>
      <p class="bookDescription body article font2">
        <p>"I stand on the edge of a cliff in my own bedroom." Gillian Marchenko continues her description of depression: "I must keep still. Otherwise I will plunge to my death. 'Please God, take this away,' I pray when I can." For Gillian, "dealing with depression" means learning to accept and treat it as a physical illness. In these pages she describes her journey through various therapies and medications to find a way to live with depression. She faces down the guilt of a wife and mother of four, two with special needs. How can she care for her family when she can't even get out of bed? Her story is real and raw, not one of quick fixes. But hope remains as she discovers that living with depression is still life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gillian Marchenko
      </h2>
      
      <p class="authorDescription body article"><p>Gillian Marchenko is an author, speaker, wife, mother of four daughters and advocate for individuals with special needs. Her memoir, <em>Sun Shine Down</em> (T. S. Poetry Press), chronicles her experience having a baby with Down syndrome while serving as a missionary in Ukraine. Gillian writes and speaks about parenting kids with Down syndrome, faith, depression, imperfection and adoption. Educated at Moody Bible Institute, she previously served with the Joni  Friends Chicago Teaching Team, helping churches cultivate inclusive environments for individuals with disabilities and their families. In addition to being featured in numerous radio interviews and guest blogging on several websites, Gillian has written for publications such as<em>Chicago Parent</em>, <em>Thriving Family</em>, <em>Gifted for Leadership</em>, <em>Today's Christian Woman</em>, <em>Literary Mama</em>, <em>MomSense Magazine</em> and <em>EFCA Today</em>. She and her husband Sergei spent four years as church planters with the Evangelical Free Church of America in Kiev, Ukraine, and they now live with their four daughters in St. Louis, Missouri.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?747922e4